import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk, AppDispatch } from 'app/store'
import { Extra } from 'features/houseInfo/types';

const initialState : typeof Extra = {
    varmepumpe: false,
    knx: false,
    z41: false,
    weather: false,
    ISE: false,
    porttlf: false,
    logging: false,
    mobile: false,
    timer: false,
    rgbw: false,
    waterdetection: false,
    solidstate: false,
    constantlight: false,
    sonos: false,
    network: false,
    port24: false,
    accesspoints: {
        selected: false,
        amount_data: 0,
        amount_access: 0,
        data_val: [],
    },
    effect: false,
    access: false,
    outside: false,
    macros: {
        selected: false,
        amount: 0,
        values: []
    },
    name: {
        varmepumpe: "Varmepumpe",
        z41: "Z41",
        weather: "Vaerstasjon",
        ISE: "ISE REMOTE",
        porttlf: "Porttelefon",
        logging: "Logging av temperatur inne og ute",
        mobile: "Mobil/PAD losning",
        timer: "Timer på stikkontakt",
        rgbw: "RGBW belysning",
        waterdetection: "Vanndeteksjon",
        solidstate: "Solidstate på varmekabel",
        constantlight: "Konstantlys styring",
        sonos: "Integrering med SONOS",
        network: "Nettverk",
        port24: "24 ports  svitsj",
        effect: "Effektstyring",
        outside: "Utelys",
        knx: "ThinKnx"
    }
};

const extraSlice = createSlice({
    name: "extra",
    initialState,
    reducers: {
        storeExtraFunc(state, action: PayloadAction<typeof Extra>){
            console.log(action)
            state.ISE = action.payload["ISE"];
            state.access = action.payload["access"];
            state.varmepumpe = action.payload["varmepumpe"];
            state.z41 = action.payload["z41"];
            state.waterdetection = action.payload["waterdetection"];
            state.weather = action.payload["weather"];
            state.porttlf = action.payload["porttlf"];
            state.logging = action.payload["logging"];
            state.mobile = action.payload["mobile"];
            state.timer = action.payload["timer"];
            state.rgbw = action.payload["rgbw"];
            state.solidstate = action.payload["solidstate"];
            state.sonos = action.payload["sonos"];
            state.constantlight = action.payload["constantlight"];
            state.network = action.payload["network"];
            state.effect = action.payload["effect"];
            state.outside = action.payload["outside"];
            state.effect = action.payload["effect"];
            state.port24 = action.payload["port24"];
            state.macros.amount = action.payload["macros"]["amount"];
            state.macros.selected = action.payload["macros"]["selected"];
            state.macros.values = action.payload["macros"]["values"];
            state.accesspoints.selected = action.payload["accesspoints"]["selected"];
            state.accesspoints.amount_access = action.payload["accesspoints"]["amount_access"];
            state.accesspoints.amount_data = action.payload["accesspoints"]["amount_data"];
            state.accesspoints.data_val = action.payload["accesspoints"]["data_val"];
            state.knx = action.payload["knx"];
        },
        storeMacroVal(state, action: PayloadAction<any[]>){
            state.macros.values = action.payload
        },
        storeDataVal(state, action: PayloadAction<any[]>){
            state.accesspoints.data_val = action.payload
        }
    }
})

export const storeExtraFunc = (
    values: typeof Extra
) : AppThunk => async(dispatch: AppDispatch) => {
    const updatedExtra: typeof Extra = {
        varmepumpe: values["varmepumpe"],
        z41: values["z41"],
        weather: values["weather"],
        ISE: values["ISE"],
        porttlf: values["porttlf"],
        logging: values["logging"],
        mobile: values["mobile"],
        timer: values["timer"],
        rgbw: values["rgbw"],
        waterdetection: values["waterdetection"],
        solidstate: values["solidstate"],
        constantlight: values["constantlight"],
        sonos: values["sonos"],
        network: values["network"],
        port24: values["port24"],
        accesspoints: {
            selected: values["accesspoints"]["selected"],
            amount_data: values["accesspoints"]["amount_data"],
            amount_access: values["accesspoints"]["amount_access"],
            data_val: values["accesspoints"]["data_val"],
        },
        effect: values["effect"],
        access: values["access"],
        outside: values["outside"],
        knx: values["knx"],
        macros: {
            selected: values["macros"]["selected"],
            amount: values["macros"]["amount"],
            values: values["macros"]["values"]
        },
    }
    dispatch(extraSlice.actions.storeExtraFunc(updatedExtra))
}

export const storeMacroVal = (
    m_arr: any[]
): AppThunk => async(dispatch: AppDispatch) => {
    dispatch(extraSlice.actions.storeMacroVal(m_arr))
}

export const storeDataVal = (
    m_arr: any[]
): AppThunk => async(dispatch: AppDispatch) => {
    dispatch(extraSlice.actions.storeDataVal(m_arr))
}



export default extraSlice.reducer;